import { Component, OnInit } from '@angular/core';
import { FileService } from '../../../shared/_services/file.service';
@Component({
  selector: 'app-download-feedback',
  templateUrl: './download-feedback.component.html',
  styleUrls: ['./download-feedback.component.css']
})
export class DownloadFeedbackComponent implements OnInit {

  filePath: any;
  constructor(private fileService: FileService) { }

  ngOnInit() {
  }

  downloadFeedback() {
    this.fileService.downloadFeedback("Resultado.xlsx");
  }

}
